export const isProduction = true;

export const herokuURL = isProduction
  ? "https://api.fanmarketcap.com"
  : "https://staging.fanmarketcap.com";

// export const herokuURL = "http://localhost:4000";
